import { PartialNullable } from "../../Extensions";
import { PropertyChange } from "../../PropertyChange";
import { Property } from "../../RadObject";
import { ContainerControl, ContainerControlPropertyValues, IContainerControl } from "./ContainerControl";
import { NAMESPACE } from "./_Namespace";

import "./Panel.scss";

export enum PanelStyleEnum
{
    none = "none",
    bordered = "bordered",
}

export type PanelPropertyValues =
    ContainerControlPropertyValues
    & {
        style: PanelStyleEnum;
    };

export type PanelProperties = {
    [name in keyof PanelPropertyValues]: Property<PanelPropertyValues[name]>
};

export interface IPanel extends IContainerControl, PanelProperties
{
}

export class Panel extends ContainerControl implements IPanel
{
    // #region Static

    public static override classNamespace = NAMESPACE + "Panel";
    public static override className = "Panel";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<PanelPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                style: PanelStyleEnum.none,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Properties

    public style!: Property<PanelStyleEnum>;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<PanelPropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("rad-control-panel");

        // Trigger Property Changes
        this.style.triggerChange();
    }

    // #endregion

    // #region Protected Methods

    protected _styleChanged(change: PropertyChange<PanelStyleEnum>)
    {
        const
            $$element = this.$$element.get();

        if (change.currentValue === "bordered")
            $$element?.addClass("rad-style-bordered");
        else
            $$element?.removeClass("rad-style-bordered");
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: PanelPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.style = new Property<PanelStyleEnum>(this, "System.String, System.Private.CoreLib", propertyValues.style, this._styleChanged);
    }

    // #endregion

    // #endregion
}